import { Theme } from '@mui/material/styles/createTheme';
import { getSiteName, GetSiteNameInput } from '@provision/formatting-utils';
import { portalPaths } from '@provision/portal-routes';
import { DynamicIcon } from 'src/components';
import { ActivityMessage } from 'src/components/ActivityList/activity-list-item';
import { ActivityRefChip } from 'src/components/ActivityList/activity-ref-chip';
import { ActivityFeed } from 'src/graphql/entities/activity-feed/hooks/use-activity-feed';

export const buildClientToAddressMessage = (activity: ActivityFeed): ActivityMessage[] => {
  const actorName = activity.actor?.name?.trim() || '<Platform User>';
  const address = activity.changes.reduce(
    (acc, item) => ({
      ...acc,
      [item.name]: item.value,
    }),
    {} as GetSiteNameInput & {
      id: string;
      brandName: string;
    },
  );

  const fullAddress = getSiteName(address);
  const icon = address.brandName?.toLowerCase().includes('commercial') ? 'domain' : 'home';

  switch (activity.activityType) {
    case 'createN2NRelationship': {
      return [
        {
          id: activity.id,
          icon: 'join_inner',
          color: (theme: Theme) => theme.palette.custom.OV.sys.primary,
          message: (
            <>
              {actorName} associated{' '}
              <ActivityRefChip
                label={fullAddress}
                icon={<DynamicIcon name={icon} weight={500} />}
                iconColor={(theme) => theme.palette.custom.OV.sys.tertiary}
                clickable
                path={portalPaths.site.full(address.id)}
              />
            </>
          ),
          timestamp: activity.timestamp,
        },
      ];
    }
    case 'deleteN2NRelationship': {
      return [
        {
          id: activity.id,
          icon: 'link_off',
          color: (theme: Theme) => theme.palette.custom.OV.sys.error,
          message: (
            <>
              {actorName} removed{' '}
              <ActivityRefChip
                label={fullAddress}
                icon={<DynamicIcon name={icon} weight={500} />}
                iconColor={(theme) => theme.palette.custom.OV.sys.tertiary}
                clickable
                path={portalPaths.site.full(address.id)}
              />
            </>
          ),
          timestamp: activity.timestamp,
        },
      ];
    }
    default:
      return [];
  }
};
